import { render, staticRenderFns } from "./labelDatasetManage.vue?vue&type=template&id=75947ceb&scoped=true"
import script from "./labelDatasetManage.vue?vue&type=script&lang=js"
export * from "./labelDatasetManage.vue?vue&type=script&lang=js"
import style0 from "./labelDatasetManage.vue?vue&type=style&index=0&id=75947ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75947ceb",
  null
  
)

export default component.exports